// @ts-nocheck
import React, { useState, useEffect, useContext } from 'react';
import Router from 'next/router';
import Link from 'next/link';
import TextInput from '@/components/text-input';
import {Button, Loader, Text, Flex, Fieldset} from "@mantine/core";
import {IconDownload, IconFileDatabase, IconInfoCircle, IconUpload} from "@tabler/icons";
import DownloadService from "@/utils/download-service";
import { getApiHost } from '@/utils/auth';
import * as Enums from '@/utils/enums';
import ToastContext from '@/utils/toast-context';
import SettingsMenu from '@/components/settings/menu';
import Storage from '@/utils/storage';
import Helper from '@/utils/helper';
import BusyIndicatorContext from '@/utils/busy-indicator-context';
import constants from '@/utils/constants';
import SCDropdownList from '@/components/sc-controls/form-controls/sc-dropdownlist';
import PS from '@/services/permission/permission-service';
import { createFileRoute } from '@tanstack/react-router'



const exportPermission = PS.hasPermission(Enums.PermissionName.Exports)

function CreateImport() {

  const busyIndicator = useContext(BusyIndicatorContext);

  let currPath = '';
  if (Router.router) {
    currPath = Router.router.asPath;
  }

  const toast = useContext(ToastContext);

  const [enableImport, setEnableImport] = useState(false);

  const importTypes = Enums.getEnumItems(Enums.ImportType);
  const [importTypeText, setImportTypeText] = useState('');
  const [selectedImportType, setSelectedImportType] = useState<any>();


  const [accessStatus, setAccessStatus] = useState(Enums.AccessStatus.None);
  const getAccessStatus = () => {
    let subscriptionInfo = Storage.getCookie(Enums.Cookie.subscriptionInfo);
    if (subscriptionInfo) {
      setAccessStatus(subscriptionInfo.AccessStatus);
    }
  }

  useEffect(() => {
    getAccessStatus();
  }, []);

  useEffect(() => {
    if (accessStatus === Enums.AccessStatus.LockedWithAccess || accessStatus === Enums.AccessStatus.LockedWithOutAccess) {
      Helper.nextRouter(Router.replace, "/");
    }
  }, [accessStatus]);

  const handleImportTypeChange = (e: any) => {
    console.log(e);
    setImportTypeText(e.target.value);
  }

  const [url, setUrl] = useState('');
  useEffect(() => {
    if (selectedImportType) {
      setUrl(`/Import?importType=${Enums.ImportType[selectedImportType]}`);
      setEnableImport(true);
    } else {
      setEnableImport(false);
    }
  }, [selectedImportType]);

  const [uploading, setUploading] = useState(false);
  const [fileChosen, setFileChosen] = useState(false);

  const [file, setFile] = useState<any>();
  useEffect(() => {
    if (file) {
      setFileName(file.name);
      setFileChosen(true);
    }
  }, [file]);

  const [fileName, setFileName] = useState('');
  const handleFileNameChange = (e: any) => {
    setFileName(e.target.value);
  }

  const [downloading, setDownloading] = useState(false);
  const [downloadingWithData, setDownloadingWithData] = useState(false);

  const ImportTypesWithData = [
    Enums.ImportType.Asset,
    Enums.ImportType.Customer,
    Enums.ImportType.Inventory,
    Enums.ImportType.CustomerContact,
    Enums.ImportType.CustomerLocation
  ];

  async function downloadFile() {
    if (!downloading) {
      setDownloading(true);
      await DownloadService.downloadFile('GET', `/Import?importType=${Enums.ImportType[selectedImportType]}`, null, false, false, "", "", null, false, (() => {
        setDownloading(false);
      }));
    }
  }

  async function downloadFileWithData() {
    if (!downloadingWithData) {
      setDownloadingWithData(true);
      await DownloadService.downloadFile('GET', `/Import/DownloadTemplateWithData/?importType=${Enums.ImportType[selectedImportType]}`, null, false, false, "", "", null, false, (() => {
        setDownloadingWithData(false);
      }));
    }
  }

  function chooseFile() {
    document.getElementById('js-input').click();
  }

  async function handleFileChange(e: any) {
    let file = e.target.files[0];
    if (file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || file.type === 'application/vnd.ms-excel') {
      setFile(file);
    } else {
      toast.setToast!!!({
        message: 'Please select a valid file',
        show: true,
        type: 'error'
      });
    }
  }

  async function submitImport() {

    setUploading(true);
    busyIndicator.setText!!!("Uploading...");

    const token = Storage.getCookie(Enums.Cookie.token);
    const deviceid = Storage.getCookie(Enums.Cookie.fingerPrint);

    let reader = new FileReader();

    const apiHost = getApiHost();

    reader.onloadend = async function () {
      // Remove Data URI from B64 String
      var b64 = (reader.result as any).replace(/^data:.+;base64,/, '');
      const res = await fetch(apiHost + '/Import', {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'deviceid': deviceid,
          'tenantid': Storage.getCookie(Enums.Cookie.tenantID),
          'SC-Version': __APP_VERSION__
        },
        body: JSON.stringify({
          FileName: file.name,
          FileBase64: b64,
          ImportType: Enums.ImportType[selectedImportType],
        })
      });

      if (res.status == 200) {
        Helper.mixpanelTrack(constants.mixPanelEvents.createImport, {
          importType: selectedImportType
        });
        Helper.nextRouter(Router.push, `/settings/import/list`);
      } else {
        toast.setToast!!!({
          message: 'Import failed',
          show: true,
          type: 'error'
        });
        setUploading(false);
      }
    };
    reader.readAsDataURL(file);
    busyIndicator.setText!!!(null);
  }

  return (
    <div className="settings-container">
      {/*<div className="row">
        <div className="title">
          <Breadcrumbs crumbs={[
            { text: 'Imports', link: '/settings/import/list' },
            { text: 'Create an Import', link: '' }
          ]} />
        </div>
      </div>*/}
      <div className="row">
        <SettingsMenu urlPath={currPath} />
        <div className="settings-card">
          <div className="row">
            <h3>Import Details</h3>
          </div>
          <div className="row">
            <div className="column">
              <Text size={'sm'} c={'dimmed'}>
                Importing customers or inventory from another system?{' '}
                <Link href="/settings/import/smart">Smart import</Link> accepts files in any layout and matches the columns for you.
              </Text>
            </div>
            <div className="column"></div>
          </div>
          <div className="row">
            <div className="column">
              <SCDropdownList
                options={importTypes}
                onChange={setSelectedImportType}
                value={importTypeText}
                label="Import Type"
                required={true}
              />

              {/* <SelectInput
                changeHandler={handleImportTypeChange}
                label="Import Type"
                options={importTypes}
                placeholder="Select import type"
                required={true}
                noInput={true}
                setSelected={setSelectedImportType}
                type="enum"
                value={importTypeText} 
              />*/}
            </div>
            <div className="column"></div>
          </div>
          {enableImport &&
            <>
              <div className="row">
                <div className="column">
                  <Button color={'scBlue'} w={'100%'} mt={'var(--mantine-spacing-xl)'} onClick={downloadFile} rightSection={downloading ? <Loader size={16} color={'blue.0'} /> : <IconDownload size={18} />}>
                    Download Blank Template
                  </Button>
                </div>
                <div className="column"></div>
              </div>
              {ImportTypesWithData.includes(Enums.ImportType[selectedImportType]) && exportPermission &&
                <div className="row">
                  <div className="column">
                    <Flex my={3} justify={'center'}>
                      <Text size={'sm'}>OR</Text>
                    </Flex>
                    <Button variant={'gradient'} color={'scBlue'} w={'100%'} onClick={downloadFileWithData} rightSection={downloadingWithData ? <Loader size={16} color={'blue.0'} /> : <IconDownload size={18} />}>
                      Download Template With Existing Data
                    </Button>
                  </div>
                  <div className="column"></div>
                </div>
              }

              <div className="row">
                <div className="column">
                  <Fieldset
                      legend="Then"
                      w={'100%'}
                      mt={'xl'}
                      pb={'xs'}
                      disabled={uploading}
                      px={0}
                      styles={{
                        legend: {
                          textAlign: 'center',
                          margin: 'auto'
                        },
                        root: {
                          paddingTop: 2,
                          borderLeft: 'none',
                          borderRight: 'none',
                          borderBottom: 'none',
                          borderRadius: 0
                        }
                      }}
                  >
                    <Button w={'100%'} onClick={() => chooseFile()} mt={'sm'} mb={'5'} rightSection={<IconFileDatabase size={16} />}>
                      Select Your Import File
                    </Button>
                  </Fieldset>
                  <Text size={'sm'} c={'dimmed'}>
                    <Flex align={'center'} gap={5}>
                      <IconInfoCircle size={16}  /> <strong> How to use the template:</strong>
                    </Flex>
                    <ol style={{ paddingLeft: '1rem' }}>
                      <li>
                        Start by downloading the template with, or without, pre-existing data (if you haven&apos;t already).
                      </li>
                      <li>
                        Open the downloaded template on your device and add the items you wish to import.
                      </li>
                      <li>
                        Click &apos;Select Your Import File&apos; and choose your updated import template.
                      </li>
                      <li>
                        We will take care of the rest ; )
                      </li>
                    </ol>
                    <strong>Note:</strong>
                    <br />
                    - The file must be a .xlsx or .xls file.
                    <br />
                    - The file must be in the same format as the template.
                  </Text>
                </div>
                <div className="column"></div>
              </div>
            </>
          }
          {fileChosen ?
            <>
              <div className="row">
                <div className="column">
                  <TextInput label="File" readOnly={true} changeHandler={handleFileNameChange} value={fileName} />
                </div>
                <div className="column"></div>
              </div>
              <div className="row">
                <div className="column">
                  <Button onClick={submitImport} disabled={uploading} mt={'sm'} rightSection={uploading ? <Loader size={16} color={'blue.0'} /> : <IconUpload size={18} />}>
                    Create Import
                  </Button>
                </div>
                <div className="column"></div>
              </div>
            </>
            : ''}
        </div>
      </div>

      <input type="file" id="js-input" className="hidden-file-input" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" onChange={handleFileChange} />

      <style jsx>{`
      .row {
        display: flex;
        justify-content: space-between;
      }
      .column {
        display: flex;
        flex-basis: 0;
        flex-direction: column;
        flex-grow: 1;
        max-width: 500px;
      }
      .column :global(.textarea-container) {
        height: 100%;
      }
      .column + .column {
        margin-left: 1.25rem;
      }
      .hidden-file-input {
        display: none;
      }
    `}</style>
    </div >
  );
}

export default CreateImport;

export const Route = createFileRoute('/_authenticated/settings/import/create')({ component: CreateImport })
